module.exports = __webpack_public_path__ + "img/zhibanguanli.8d937409.png";